export default __webpack_public_path__ + "static/media/Vambraces of the Bloodhunter.9b2e8820.jpg";